"use strict";

exports.__esModule = true;
exports.default = void 0;
var _index = require("./index");
var _actionTypes = require("../modules/base/actionTypes");
var _v = _interopRequireDefault(require("uuid/v1"));
var _axios = _interopRequireDefault(require("axios"));
var _WebRequestHelper = require("./WebRequestHelper");
var _actions = require("../modules/auth/actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable no-undef */
const CancelToken = _axios.default.CancelToken;
class ActionHelper {
  constructor(options) {
    _defineProperty(this, "init", data => {
      return dispatch => {
        dispatch({
          type: `INIT_${this._PLURAL}`,
          data: data
        });
      };
    });
    _defineProperty(this, "clearSingle", () => {
      return dispatch => {
        dispatch({
          type: `CLEAR_${this._SINGULAR}`
        });
      };
    });
    _defineProperty(this, "create", (body, params, module, useAuthentication = true) => {
      console.log(params);
      Object.entries(body).map(([key, value]) => {
        // First strip away objects because the could behave unexpected on the server side
        if (Array.isArray(value)) value.map((a, index) => {
          Object.entries(a).map(([k, v]) => {
            if (Object.prototype.toString.call(v) === "[object Object]") delete body[key][index][k];
          });
        });
      });
      return dispatch => {
        dispatch({
          type: "CREATE_" + this._SINGULAR + "_REQUEST"
        });
        return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
          request.method = "post";
          request.url = `${this._uri}?expand=${params}`;
          request.data = body;
          if (module && module.preCreate !== undefined) {
            request = module.preCreate(request, params);
          }
          return (0, _WebRequestHelper.sendRequest)(request).then(response => {
            if (module && module.postCreate !== undefined) {
              response = module.postCreate(response);
            }
            dispatch({
              type: "CREATE_" + this._SINGULAR + "_SUCCESS",
              data: response.data
            });
            return response.data;
          }).catch(error => {
            dispatch({
              type: "CREATE_" + this._SINGULAR + "_FAILURE",
              data: error.response ? error.response.data : {
                Message: "An error occurred."
              }
            });
            if (error.response && error.response.data) throw error.response.data;
            throw error;
          });
        }).catch(error => {
          dispatch({
            type: "CREATE_" + this._SINGULAR + "_FAILURE",
            data: error.response ? error.response.data : {
              Message: "An error occurred."
            }
          });
          if (error.response && error.response.data) throw error.response.data;
          throw error;
        });
      };
    });
    _defineProperty(this, "get", (id, params, module, useAuthentication = true, cancelPreviousRequests = false) => {
      if (this.source !== undefined && cancelPreviousRequests === true) {
        this.source.cancel();
      }

      //source = CancelToken.source();

      return dispatch => {
        dispatch({
          type: "GET_" + this._SINGULAR + "_REQUEST"
        });
        return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
          request.method = "get";
          request.url = `${this._uri}/${id}${(0, _index.paramsToString)(params)}`;
          //request.cancelToken = source.token;

          if (module && module.preGet !== undefined) {
            request = module.preGet(request, id, params);
          }
          return (0, _WebRequestHelper.sendRequest)(request).then(response => {
            if (module && module.postGet !== undefined) {
              response = module.postGet(response);
            }
            dispatch({
              type: "GET_" + this._SINGULAR + "_SUCCESS",
              data: response.data
            });
            return response.data;
          }).catch(error => {
            dispatch({
              type: "GET_" + this._SINGULAR + "_FAILURE",
              data: error.response ? error.response.data : {
                Message: "An error occurred."
              }
            });
            dispatch({
              type: _actionTypes.CREATE_BASE_FAILURE,
              data: error.response ? error.response.data : {
                Message: "An error occurred."
              }
            });
          });
        }).catch(err => console.log(err));
      };
    });
    _defineProperty(this, "getAll", (params, module, useAuthentication = true, cancelPreviousRequests = true, history) => {
      if (this.source !== undefined && cancelPreviousRequests === true) {
        this.source.cancel();
      }
      this.source = CancelToken.source();
      return dispatch => {
        dispatch({
          type: "GET_" + this._PLURAL + "_REQUEST"
        });
        return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
          request.method = "get";
          request.url = `${this._uri}${(0, _index.paramsToString)(params)}`;
          request.cancelToken = this.source.token;
          if (module && module.preGetAll !== undefined) {
            module.preGetAll(request, params).then(request => {
              return (0, _WebRequestHelper.sendRequest)(request).then(response => {
                if (module && module.postGetAll !== undefined) {
                  module.postGetAll(response, dispatch, useAuthentication, this.source);
                }
                dispatch({
                  type: "GET_" + this._PLURAL + "_SUCCESS",
                  data: response.data,
                  total: response.headers["x-total-count"]
                });
              }).catch(error => {
                if (_axios.default.isCancel(error)) {
                  // Request canceled
                } else {
                  console.log("Yo I'm here first catch");
                  if (error.response && error.response.status === 401) {
                    // Do something specific for 401 error
                    console.log("Unauthorized access. Redirect or handle accordingly.");
                    return dispatch((0, _actions.signOut)()).then(() => {
                      console.log("Redirecting...");
                      window.location.replace("/sign-in");
                    });
                  } else {
                    dispatch({
                      type: "GET_" + this._PLURAL + "_FAILURE",
                      data: error.response ? error.response : {
                        Message: "An error occurred!"
                      }
                    });
                    dispatch({
                      type: _actionTypes.CREATE_BASE_FAILURE,
                      data: error.response ? error.response.data : {
                        Message: "An error occurred."
                      }
                    });
                    console.dir(error);
                  }
                }
              });
            });
          } else {
            return (0, _WebRequestHelper.sendRequest)(request).then(response => {
              if (module && module.postGetAll !== undefined) {
                module.postGetAll(response, dispatch, useAuthentication, this.source);
              }
              dispatch({
                type: "GET_" + this._PLURAL + "_SUCCESS",
                data: response.data,
                total: response.headers["x-total-count"]
              });
            }).catch(error => {
              if (_axios.default.isCancel(error)) {
                // Request canceled
              } else {
                console.log("Yo I'm here second catch");
                if (error.response && error.response.status === 401) {
                  // Do something specific for 401 error
                  console.log("Unauthorized access. Redirect or handle accordingly.");
                  return dispatch((0, _actions.signOut)()).then(() => {
                    console.log("Redirecting...");
                    window.location.replace("/sign-in");
                  });
                } else {
                  dispatch({
                    type: "GET_" + this._PLURAL + "_FAILURE",
                    data: error.response ? error.response : {
                      Message: "An error occurred"
                    }
                  });
                  dispatch({
                    type: _actionTypes.CREATE_BASE_FAILURE,
                    data: error.response ? error.response.data : {
                      Message: "An error occurred"
                    }
                  });
                  console.dir(error);
                }
              }
            });
          }
        }).catch(err => console.log(err));
      };
    });
    _defineProperty(this, "update", (id, body, params, module, useAuthentication = true) => {
      Object.entries(body).map(([key, value]) => {
        // First strip away objects because the could behave unexpected on the server side
        if (Object.prototype.toString.call(value) === "[object Object]") delete body[key];
      });
      return dispatch => {
        dispatch({
          type: `UPDATE_${this._SINGULAR}_REQUEST`
        });
        return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
          request.method = "put";
          request.url = `${this._uri}/${id}${(0, _index.paramsToString)(params)}`;
          request.data = body;
          if (module && module.preUpdate !== undefined) {
            request = module.preUpdate(request, id, params);
          }
          return (0, _WebRequestHelper.sendRequest)(request).then(response => {
            if (module && module.postUpdate !== undefined) {
              response = module.postUpdate(response);
            }
            dispatch({
              type: "UPDATE_" + this._SINGULAR + "_SUCCESS",
              data: response.data
            });
            return response.data;
          }).catch(error => {
            dispatch({
              type: "UPDATE_" + this._SINGULAR + "_FAILURE",
              data: error.response ? error.response.data : {
                Message: "An error occurred."
              }
            });
            if (error.response && error.response.data) throw error.response.data;
            throw error;
          });
        }).catch(error => {
          dispatch({
            type: "UPDATE_" + this._SINGULAR + "_FAILURE",
            data: error.response ? error.response.data : {
              Message: "An error occurred."
            }
          });
          if (error.response && error.response.data) throw error.response.data;
          throw error;
        });
      };
    });
    _defineProperty(this, "select", (checked, id) => {
      return dispatch => {
        checked ? dispatch({
          type: "SELECT_" + this._SINGULAR,
          id
        }) : dispatch({
          type: "DESELECT_" + this._SINGULAR,
          id
        });
      };
    });
    _defineProperty(this, "selectAll", checked => {
      return dispatch => {
        checked ? dispatch({
          type: "SELECT_ALL_" + this._PLURAL
        }) : dispatch({
          type: "DESELECT_ALL_" + this._PLURAL
        });
      };
    });
    _defineProperty(this, "flip", direction => {
      return dispatch => {
        direction ? dispatch({
          type: "FLIP_" + this._PLURAL + "_FORWARD"
        }) : dispatch({
          type: "FLIP_" + this._PLURAL + "_BACKWARD"
        });
      };
    });
    _defineProperty(this, "jump", page => {
      page = page - 1;
      return dispatch => {
        dispatch({
          type: "JUMP_" + this._PLURAL,
          data: page
        });
      };
    });
    _defineProperty(this, "limit", count => {
      return dispatch => {
        dispatch({
          type: "SET_" + this._PLURAL + "_LIMIT",
          data: count
        });
      };
    });
    _defineProperty(this, "filter", filter => {
      return dispatch => {
        dispatch({
          type: "SET_" + this._PLURAL + "_FILTER",
          data: filter
        });
      };
    });
    _defineProperty(this, "destroyFilter", filter => {
      return dispatch => {
        dispatch({
          type: "DELETE_" + this._PLURAL + "_FILTER",
          data: filter
        });
      };
    });
    _defineProperty(this, "destroyAllFilters", () => {
      return dispatch => {
        dispatch({
          type: "DELETE_ALL_" + this._PLURAL + "_FILTERS"
        });
      };
    });
    _defineProperty(this, "orderBy", orderBy => {
      return dispatch => {
        dispatch({
          type: "ORDER_BY_" + this._PLURAL,
          data: orderBy
        });
      };
    });
    _defineProperty(this, "closeError", (id, where) => {
      return dispatch => {
        dispatch({
          type: `${this._SINGULAR}_ERROR_CLOSED`,
          data: {
            id,
            where
          }
        });
      };
    });
    _defineProperty(this, "destroy", (id, module, useAuthentication = true) => {
      return dispatch => {
        dispatch({
          type: "DELETE_" + this._SINGULAR + "_REQUEST"
        });
        return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
          request.method = "delete";
          request.url = `${this._uri}/${id}`;
          if (module && module.preDestroy !== undefined) {
            request = module.preDestroy(request, id);
          }
          return (0, _WebRequestHelper.sendRequest)(request).then(response => {
            if (module && module.postDestroy !== undefined) {
              response = module.postDestroy(response);
            }
            dispatch({
              type: "DELETE_" + this._SINGULAR + "_SUCCESS",
              data: {
                Id: id
              }
            });
            return response.data;
          }).catch(error => {
            dispatch({
              type: "DELETE_" + this._SINGULAR + "_FAILURE",
              data: error.response ? error.response.data : {
                Message: "An error occurred."
              }
            });
            if (error.response && error.response.data) throw error.response.data;
            throw error;
          });
        }).catch(err => console.log(err));
      };
    });
    _defineProperty(this, "destroyBatch", (selection, module, useAuthentication = true) => {
      return dispatch => {
        let i = 0;
        const result = () => {
          return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
            request.method = "delete";
            request.url = `${this._uri}/${selection[i]}`;
            if (module && module.preDestroyBatch !== undefined) {
              request = module.preDestroyBatch(request);
            }
            return (0, _WebRequestHelper.sendRequest)(request).then(response => {
              if (module && module.postDestroyBatch !== undefined) {
                module.postDestroyBatch(response, dispatch);
              }
              dispatch({
                type: `DELETE_${this._SINGULAR}_SUCCESS`,
                data: {
                  Id: selection[i]
                }
              });
              i++;
              if (i >= selection.length) return "done";
              return result();
            }).catch(error => {
              dispatch({
                type: `DELETE_${this._SINGULAR}_FAILURE`,
                data: error.response ? {
                  ...error.response.data,
                  id: (0, _v.default)()
                } : {
                  Message: "An error occurred.",
                  id: (0, _v.default)()
                }
              });
              i++;
              if (i >= selection.length) return "done";
              return result();
            });
          }).catch(err => console.log(err));
        };
        return result();
      };
    });
    _defineProperty(this, "createBatch", (array, module, useAuthentication = true) => {
      return dispatch => {
        let i = 0;
        return (0, _WebRequestHelper.createRequest)(useAuthentication).then(request => {
          request.method = "post";
          request.url = `${this._uri}`;
          request.data = array[i];
          if (module && module.preCreateBatch !== undefined) {
            request = module.preCreateBatch(request);
          }
          return (0, _WebRequestHelper.sendRequest)(request).then(response => {
            if (module && module.postCreateBatch !== undefined) {
              module.postCreateBatch(response, dispatch);
            }
            dispatch({
              type: `CREATE_${this._SINGULAR}_SUCCESS`,
              data: response.data
            });
            dispatch({
              type: "DELETE_PARSED_USER",
              data: response.data
            });
            i++;
            if (i >= array.length) return "done";
            return request();
          }).catch(error => {
            dispatch({
              type: `CREATE_${this._SINGULAR}_FAILURE`,
              data: error.response ? error.response.data : {
                Message: "An error occurred."
              }
            });
            i++;
            if (i >= selection.length) return "done";
            return request();
          });
        }).catch(err => console.log(err));
      };
    });
    this._singular = options.singular || (options.plural ? options.plural.slice(0, -1) : null);
    this._plural = options.plural || (options.singular ? options.singular + "s" : null);
    this._SINGULAR = this._singular.toUpperCase();
    this._PLURAL = this._plural.toUpperCase();
    this._uri = "/" + (options.endpoint || this._plural);
  }
}
var _default = exports.default = ActionHelper;
module.exports = exports.default;